import { render, staticRenderFns } from "./LayoutSettings.vue?vue&type=template&id=28025f6a&scoped=true&"
import script from "./LayoutSettings.vue?vue&type=script&lang=js&"
export * from "./LayoutSettings.vue?vue&type=script&lang=js&"
import style0 from "./LayoutSettings.vue?vue&type=style&index=0&id=28025f6a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28025f6a",
  null
  
)

export default component.exports